import { ToastaService } from 'ngx-toasta';
import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { AcceptedFile, RejectedFile, RejectionReasons } from '../../file-drop';
import { FileDropDirective } from '../../file-drop/directives/file-drop.directive';
import { NgClass, NgIf } from '@angular/common';
import { NexiaTooltipDirective } from '../../../tooltip/nexia-tooltip.directive';
import { MatIconModule } from '@angular/material/icon';

export class UploadFileConfig {
  constructor(
    public translatePath: string,
    public maxFiles: number = 1,
    public maximumFileSizeInBytes: number= 0,
    public svgIcon?: string
  ) {
  }
}
@Component({
    selector: 'app-upload-file',
    templateUrl: './upload-file.component.html',
    styleUrls: ['./upload-file.component.scss'],
    standalone: true,
  imports: [ NgClass, FileDropDirective, TranslateModule, NexiaTooltipDirective, MatIconModule, NgIf ]
})
export class UploadFileComponent {

  localFile: File;
  drop = false;
  @Output() uploadFile: EventEmitter<File> = new EventEmitter<File>();
  @Input() uploadFileConfig: UploadFileConfig;
  @ViewChild('file') inputFile: ElementRef;
  constructor(
    public translate: TranslateService,
    private toast: ToastaService,
    private ref: ChangeDetectorRef
  ) {
  }

  dragFileAccepted(acceptedFile: AcceptedFile) {
    // Load the image in
    const fileReader = new FileReader();
    fileReader.onload = () => {
      // Set and show the image
      this.localFile = acceptedFile.file;
      this.ref.markForCheck(); // in order to refresh localFile in template
      this.uploadFile.emit(this.localFile);
    };
    fileReader.onerror = () => {
      this.localFile = null;
    };
    // Read in the file
    fileReader.readAsDataURL(acceptedFile.file);
  }

  dragFileRejected(rejectedFile: RejectedFile) {
    // Respond to the reason for rejection
    let msg;
    if (rejectedFile.rejectionReason === RejectionReasons.FileType) {
      msg = this.translate.instant('TOASTER_MESSAGES.UPLOAD_FILE_FORMAT_ERROR');
    } else if (rejectedFile.rejectionReason === RejectionReasons.FileSize) {
      msg = this.translate.instant('TOASTER_MESSAGES.UPLOAD_FILE_SIZE_ERROR');
    } else if (rejectedFile.rejectionReason === RejectionReasons.FilesNumber) {
      msg = this.translate.instant('TOASTER_MESSAGES.UPLOAD_FILE_TOO_MANY');
    } else {
      msg = this.translate.instant('TOASTER_MESSAGES.UPLOAD_FILE_OTHER_ERROR');
    }
    this.toast.error(msg);
    this.localFile = null;
  }

}
